import React from 'react';

import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 2147483647;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Modal = styled.div`
  position: relative;
  max-width: 80vw;
  max-height: 80vh;
`;

const Image = styled.img`
  max-width: 80vw;
  max-height: 70vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
`;

const CloseButton = styled.button`
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
`;

const NavButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: white;
  font-size: 32px;
  cursor: pointer;

  &.left {
    left: -40px;
  }
  &.right {
    right: -40px;
  }
`;

const PhotoViewerModal = ({ isOpen, onClose, images, currentIndex, setCurrentIndex }) => {
  const stopPropagation = (e) => e.stopPropagation();

  if (!isOpen) return null;

  const prevImage = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : images.length - 1));
  };

  const nextImage = () => {
    setCurrentIndex((prev) => (prev < images.length - 1 ? prev + 1 : 0));
  };

  const content = (
    <Overlay onClick={onClose}>
      <Modal onClick={stopPropagation}>
        <Image src={images[currentIndex]} alt={`Foto ${currentIndex + 1}`} />
        <CloseButton onClick={onClose}><FaTimes /></CloseButton>
        {images.length > 1 && <NavButton className="left" onClick={prevImage}><FaChevronLeft /></NavButton>}
        {images.length > 1 && <NavButton className="right" onClick={nextImage}><FaChevronRight /></NavButton>}
      </Modal>
    </Overlay>
  );

  return typeof document !== 'undefined' ? createPortal(content, document.body) : content;
};

export default PhotoViewerModal;